export default __webpack_public_path__ + "static/main-1c1e48cdb550f9fcc409ada766e63a75.jpg";